import Header from "../Header";
import SearchBar from "../search-engine/SearchBar";
import React, {useState, useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import {useTranslation, withTranslation} from "react-i18next";
import dataProvider from "../../provider/api-interface";
import {Loader} from "../Loader";

import {setFilterSortProducts} from "../search-engine/Utils";

import './Catalogue.css';
import {useCabanaContext} from "../CabanaContext";
import StickyBar from "../StickyBar";

function Catalogue() {
    const {
        jwtToken,
        user,
        userType,
        wishlist,
        isLoadingWishlist,
        listCode
    } = useCabanaContext();
    const { t } = useTranslation();

    const [searchParams] = useSearchParams();

    const [isLoading] = useState<boolean>(true);
    const [query, setQuery] = useState<any>('');
    const [products, setProducts] = useState<any>(null);

    const categoryId = searchParams.get('categoryId');
    const [activeFilters] = useState<any>(searchParams.get('filter'));
    const [activeSort] = useState<any>(searchParams.get('sort'));

    const [scrollPosition] = useState(localStorage.getItem('scrollPosition') !== null ? parseInt(localStorage.getItem('scrollPosition') as string) : 0);

    /*useEffect(() => {
        if(isScrolled || localStorage.getItem('scrollPosition') === null) {
            window.addEventListener('scroll', handleScroll, {passive: true});
        }
    });*/

    useEffect(() => {
        const fetchAllProducts = async () => {
            let chosenLocale = 1;
            let languageParam = `,"chosen_cabana_locale_id":1`;

            let filterSort: any = {
                filter: "",
                sort: "",
                search: "",
            };

            if (activeFilters !== null && activeSort !== null) {
                filterSort = setFilterSortProducts(activeFilters, activeSort);
            } else if (activeFilters !== null) {
                filterSort = setFilterSortProducts(activeFilters, "");
            } else if (activeSort !== null) {
                filterSort = setFilterSortProducts("", activeSort);
            }

            let queryString = (query === '') ? `?filter={"cabana_locale_id" : ${chosenLocale}, "main_category_id" : ${categoryId}${languageParam}${filterSort.filter}${filterSort.search}}${filterSort.sort}&perPage=-1` : query;

            try {
                const response = await dataProvider.get(`product/${queryString}`, jwtToken);
                if (response !== null) {
                    setProducts(response);
                } else {
                    console.log("Errore nel recupero dei prodotti");
                }
            } catch (error) {
                console.error("Errore nella richiesta API:", error);
            }
        };

        fetchAllProducts().then(() => {});
    }, [query, wishlist]);


    const updateQuery = (newQuery: any) => {
        setQuery(newQuery)
    };

    if(user === null || isLoadingWishlist || products === null){
        return <div style={{height: "100vh", width: "100%"}}><Loader/></div>;
    }

    return (
        <div className="Catalogue" style={{minHeight: `${scrollPosition+60}px`}}>
            <Header /*hideLanguageSelect={user.role === 2}*/
                link={`/${userType}/registry/categories?id=${listCode}`} textLink={t('header.home')} wishlistUrl={(user.role === 1) ? `/${userType}/registry/${listCode}` : `/${userType}/${listCode}`} hideLogout={true} showWishlistLink={true}/>
            <StickyBar/>
            <div className="row no-gutter">
                <div className="col-12 col-lg-1 d-md-block d-none">
                </div>
                <div className="CatalogueContainer col-12 col-lg-10">
                    <div className="CatalogueTitle">
                            <span><strong
                                style={{fontFamily: 'Atacama VAR', color: '#33383C !important', fontSize: '16px', fontWeight: '400'}}>{t('catalogue')}</strong> <span style={{color: '#7B8487'}}>{products?.total} {t('productsAvailableTitle')}</span></span>
                    </div>
                    {<SearchBar
                        products={products}
                        category={categoryId}
                        wishlist={wishlist}
                        locale={1}
                        isLoading={isLoading}
                        routeType={'catalogue'}
                        searchQuery={'products'}
                        activeSort={activeSort}
                        activeFilters={activeFilters}
                        setQuery={updateQuery}
                        setFilters={() => {}}
                        setSort={() => {}}
                        setImagesLoaded={() => {}}
                        token={jwtToken}/>}
                </div>
                <div className="col-12 col-lg-1 d-md-block d-none">
                </div>
            </div>
        </div>
    );


}

export default withTranslation()(Catalogue);

